/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './recordWithMedia.defs.js'
export * as $defs from './recordWithMedia.defs.js'
